export default __webpack_public_path__ + "static/media/image46.26431ecb.png";